var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivRT" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.esEdicion
                          ? "Editar Configuración"
                          : "Ver Detalle Configuración"
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled: !_vm.validForm || _vm.btnBloquear
                              },
                              on: {
                                click: function($event) {
                                  _vm.grabarEdicion(), (_vm.btnBloquear = true)
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              },
                              on: { click: _vm.cierraMenu }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass: "h2_title",
                                                  staticStyle: {
                                                    "margin-top":
                                                      "12px!important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Información General\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Código",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.configuracion.id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configuracion,
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression: "configuracion.id"
                                            }
                                          }),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  disabled: "",
                                                  readonly: "",
                                                  label:
                                                    "\n                              Tipo Configuración",
                                                  required: "",
                                                  "no-data-text":
                                                    "Sin resultados"
                                                },
                                                model: {
                                                  value: _vm.configuracion.tipo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.configuracion,
                                                      "tipo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configuracion.tipo"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "" } },
                                            [
                                              _c("DatePicker", {
                                                attrs: {
                                                  disabled: !_vm.esEdicion,
                                                  label: "Desde",
                                                  "error-messages": _vm.errors.collect(
                                                    _vm.formFields.fechaDesde.id
                                                  ),
                                                  id:
                                                    _vm.formFields.fechaDesde
                                                      .id,
                                                  min: _vm.fechaMinima,
                                                  max: _vm.fechaMaxima
                                                },
                                                model: {
                                                  value:
                                                    _vm.formFields.fechaDesde
                                                      .value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formFields.fechaDesde,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formFields.fechaDesde.value"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "" } },
                                            [
                                              _c("TimePicker", {
                                                attrs: {
                                                  disabled: !_vm.esEdicion,
                                                  label:
                                                    _vm.formFields.horaInicio
                                                      .label,
                                                  "error-messages": _vm.errors.collect(
                                                    _vm.formFields.horaInicio.id
                                                  ),
                                                  id:
                                                    _vm.formFields.horaInicio.id
                                                },
                                                model: {
                                                  value:
                                                    _vm.formFields.horaInicio
                                                      .value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formFields.horaInicio,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formFields.horaInicio.value"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "" } },
                                            [
                                              _c("DatePicker", {
                                                attrs: {
                                                  label: "Hasta",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    _vm.formFields.fechaHasta.id
                                                  ),
                                                  id:
                                                    _vm.formFields.fechaHasta
                                                      .id,
                                                  min: _vm.fechaMinima,
                                                  max: _vm.fechaMaxima
                                                },
                                                model: {
                                                  value:
                                                    _vm.formFields.fechaHasta
                                                      .value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formFields.fechaHasta,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formFields.fechaHasta.value"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "" } },
                                            [
                                              _c("TimePicker", {
                                                attrs: {
                                                  disabled: !_vm.esEdicion,
                                                  label:
                                                    _vm.formFields.horaHasta
                                                      .label,
                                                  "error-messages": _vm.errors.collect(
                                                    _vm.formFields.horaHasta.id
                                                  ),
                                                  id:
                                                    _vm.formFields.horaHasta.id
                                                },
                                                model: {
                                                  value:
                                                    _vm.formFields.horaHasta
                                                      .value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formFields.horaHasta,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formFields.horaHasta.value"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm.configuracion.tipo == "banner"
                                        ? _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs12: "",
                                                    sm12: "",
                                                    md12: ""
                                                  }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          "required|extension|tamanio",
                                                        expression:
                                                          "'required|extension|tamanio'"
                                                      }
                                                    ],
                                                    attrs: {
                                                      label:
                                                        "Seleccione Archivo",
                                                      heigh: "",
                                                      disabled: !_vm.esEdicion,
                                                      "prepend-icon":
                                                        "attach_file",
                                                      "error-messages": _vm.errors.collect(
                                                        "archivo"
                                                      ),
                                                      "data-vv-name": "archivo",
                                                      readonly: "readonly"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.$refs.image.click()
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.fileName,
                                                      callback: function($$v) {
                                                        _vm.fileName = $$v
                                                      },
                                                      expression: "fileName"
                                                    }
                                                  }),
                                                  _c("input", {
                                                    key: _vm.idkey,
                                                    ref: "image",
                                                    staticStyle: {
                                                      display: "none"
                                                    },
                                                    attrs: {
                                                      type: "file",
                                                      disabled: !_vm.esEdicion,
                                                      accept: "image/*"
                                                    },
                                                    on: {
                                                      change: _vm.previewImage
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm.configuracion.tipo == "mensaje"
                                        ? _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    md12: "",
                                                    xl12: "",
                                                    xs12: ""
                                                  }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "text-detencion",
                                                    attrs: {
                                                      md12: "",
                                                      xl12: "",
                                                      xs12: "",
                                                      label: "Titulo",
                                                      disabled: !_vm.esEdicion
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.configuracion
                                                          .titulo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.configuracion,
                                                          "titulo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "configuracion.titulo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    md12: "",
                                                    xl12: "",
                                                    xs12: ""
                                                  }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "text-detencion",
                                                    attrs: {
                                                      label: "Contenido",
                                                      disabled: !_vm.esEdicion
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.configuracion
                                                          .mensaje,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.configuracion,
                                                          "mensaje",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "configuracion.mensaje"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: "Editar Configuración",
          mensaje: _vm.$t("mensajes.crud.editar.mensaje", {
            entidad: "Configuración"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event, false)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: "Editar Configuración",
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, true)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }